//Transform DS Time Picker value ("hh:mm") in timestamp
export const transformTime = (value: string): number => {
    const tokens = value.split(":");//hh:mm
    const controlDate: Date = new Date(1970, 0, 1, Number(tokens[0]), Number(tokens[1]));
    return controlDate.getTime()/1000;
}

export enum IParseDateFormatType {
    DATE_FORMAT1 = "DATE_FORMAT",
    DATE_FORMAT2 = "DATE_FORMAT_T00:00:00"
}

export const parseDateForDS = (date: string, type: IParseDateFormatType) => {
    //console.log(date);
    let formattedDate = "";

    if (type === IParseDateFormatType.DATE_FORMAT1) {
        formattedDate = date.replace(/\//g, '.');
    }

    if (type === IParseDateFormatType.DATE_FORMAT2) {
        // qui mi arriva una data nella forma 2024-11-12T00:00:00 e voglio averla come 12.11.2024
        const [year, month, day] = date.split('T')[0].split('-');
        formattedDate = `${day}.${month}.${year}`;
    }
    //console.log(formattedDate);
    return formattedDate;
}